import React, { useRef, useEffect } from 'react';

const OtpInput = ({ value, onChange, error, disabled }) => {
  const inputRefs = useRef([]);
  const otpLength = 6;

  useEffect(() => {
    // Focus first input on mount
    if (inputRefs?.current?.[0]) {
      inputRefs?.current?.[0]?.focus();
    }
  }, []);

  const handleChange = (index, inputValue) => {
    const newValue = inputValue?.replace(/\D/g, '');

    if (newValue?.length <= 1) {
      const newOtp = value?.split('');
      newOtp[index] = newValue;
      onChange(newOtp?.join(''));

      // Auto-focus next input
      if (newValue && index < otpLength - 1) {
        inputRefs?.current?.[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e?.key === 'Backspace' && !value?.[index] && index > 0) {
      inputRefs?.current?.[index - 1]?.focus();
    }

    if (e?.key === 'ArrowLeft' && index > 0) {
      inputRefs?.current?.[index - 1]?.focus();
    }

    if (e?.key === 'ArrowRight' && index < otpLength - 1) {
      inputRefs?.current?.[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e?.preventDefault();
    const pastedData = e?.clipboardData?.getData('text')?.replace(/\D/g, '');

    if (pastedData?.length === otpLength) {
      onChange(pastedData);
      inputRefs?.current?.[otpLength - 1]?.focus();
    }
  };

  return (
    <div className="space-y-4">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          کد تأیید را وارد کنید
        </h3>
        <p className="text-sm text-muted-foreground">
          کد ۶ رقمی ارسال شده به شماره موبایل شما را وارد کنید
        </p>
      </div>
      <div className="flex justify-center gap-3" dir="ltr">
        {Array.from({ length: otpLength }, (_, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={value?.[index] || ''}
            onChange={(e) => handleChange(index, e?.target?.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            disabled={disabled}
            className={`
              w-12 h-12 text-center text-lg font-semibold rounded-lg border-2
              transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20
              ${
                error
                  ? 'border-destructive text-destructive bg-destructive/5'
                  : 'border-border text-foreground bg-input hover:border-primary/50 focus:border-primary'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-text'}
            `}
          />
        ))}
      </div>
      {error && (
        <p className="text-sm text-destructive text-center mt-2">{error}</p>
      )}
      <div className="text-center">
        <p className="text-sm text-muted-foreground">
          کد را دریافت نکردید؟{' '}
          <button
            type="button"
            className="text-primary hover:underline font-medium"
            disabled={disabled}>
            ارسال مجدد
          </button>
        </p>
      </div>
    </div>
  );
};

export default OtpInput;
